import { useForm, type SubmitHandler } from "react-hook-form"
import Typography from '@mui/material/Typography'

import useFormLocalStorage from "@/hooks/use-form-local-storage"
import { APP_VERSION } from "@/constants/general"
import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import RHFTextarea from "@/components/form-fields/rhf-textarea"
import type {
    RemappedBin,
    CreateCommunicationFormInput,
} from "@/types"
import { useCreateBinReplacementRequest } from "@/hooks/api/use-communication"

const CreateBinReplacementRequestForm = ({
    bin,
    municipalityId,
    closeCallback,
    toggleSuccess,
} : {
    bin: RemappedBin,
    municipalityId: string | number,
    closeCallback?: () => void,
    toggleSuccess: () => void,
}) => {

    const formDataId = `createAttributesChangeRequestForm-${municipalityId}-v${APP_VERSION}`

    const initialValues = {
        description: '',
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const [isLoadedFromLocalStorage, handleFormReset] = useFormLocalStorage({
        control,
        formDataId,
        reset,
        initialValues
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
    } = useFormStates(handleFormReset)

    const binSummary = `Nádoba: ${bin.rfid} - ${bin.type.label} - (${bin.volume}, ${bin.material})`

    const mutation = useCreateBinReplacementRequest(
        binSummary,
        municipalityId,
        {
            setRequestInProgress,
            formDataId,
            onSuccessCallback: toggleSuccess,
        }
    )

    const onSubmit: SubmitHandler<CreateCommunicationFormInput> = data => {
        setRequestInProgress(true)
        mutation.mutate(data)
    }

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            heading={'Žádost o výměnu nádoby'}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={isLoadedFromLocalStorage}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            buttonText={'Odeslat'}
        >
            <Typography>
                {binSummary}
            </Typography>
            <RHFTextarea
                name="description"
                control={control}
                label="Důvod výměny"
                size="small"
                required
            />
        </Form>
    )
}

export default CreateBinReplacementRequestForm
